import Link from 'next/link';
import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { SearchGameCategories } from '../../SearchGameCategories';
import type { ISearchFallbackScenariosProps } from '..';
import { ScSearchFallbackScenario } from '../styled';

type ProviderScenarioCAProps = ISearchFallbackScenariosProps;

export const ProviderScenarioCA: React.FC<ProviderScenarioCAProps> = ({
  gridOptions,
  handleSearchGameClick,
  sendSearchResultAppearance,
  closeModal,
}) => {
  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });
  }, []);

  return (
    <>
      <ScSearchFallbackScenario>
        <div className="text">
          <p>
            <Trans
              components={{
                l: (
                  <Link
                    className="link"
                    href="?modal=providers"
                    onClick={closeModal}
                  />
                ),
              }}
              i18nKey="searchFallback.subtitle.providerCA"
              ns="lobby"
            />
          </p>
        </div>
      </ScSearchFallbackScenario>
      <SearchGameCategories
        gridOptions={gridOptions}
        handleSearchGameClick={handleSearchGameClick}
      />
    </>
  );
};
